window.LifeNuvaTheme = window.LifeNuvaTheme || {};
window.LifeNuvaTheme.version = 'os2-storefront-85';

(function () {
  var BACKUP_KEY = 'lifenuva_cart_backup';
  var RESTORE_KEY = 'lifenuva_cart_restore';

  function rootUrl() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function fetchJson(url, options) {
    return fetch(url, options).then(function (response) {
      if (!response.ok) throw new Error('Request failed: ' + response.status);
      return response.json();
    });
  }

  function cartDiscountCodes(cart) {
    return (cart && cart.discount_codes ? cart.discount_codes : []).filter(function (item) {
      return item && item.code;
    });
  }

  function stripDiscountQuery() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has('discount')) return;
      url.searchParams.delete('discount');
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    } catch (error) {
      // Ignore malformed URLs in older browsers.
    }
  }

  function clearDiscountCookies() {
    document.cookie.split(';').forEach(function (part) {
      var name = part.split('=')[0].trim();
      if (!name || !/discount/i.test(name)) return;
      document.cookie = name + '=; path=/; max-age=0';
    });
  }

  function cartNeedsDiscountClear(cart) {
    if (!cart) return false;
    if (cartDiscountCodes(cart).length) return true;
    return Number(cart.total_discount || 0) > 0;
  }

  function postDiscountClear() {
    return fetch(rootUrl() + 'cart/update.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: '' })
    }).then(function (response) {
      if (response.ok) return response.json();
      if (response.status === 400 || response.status === 422) {
        return fetchJson(rootUrl() + 'cart.js', {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });
      }
      return fetch(rootUrl() + 'cart/update.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        credentials: 'same-origin',
        body: 'discount='
      }).then(function (retry) {
        if (retry.ok) return retry.json();
        return fetchJson(rootUrl() + 'cart.js', {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });
      });
    });
  }

  function clearPersistedDiscountCodes(options) {
    var force = !!(options && options.force);
    stripDiscountQuery();
    clearDiscountCookies();
    return fetchJson(rootUrl() + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (cart) {
      if (!force && !cartNeedsDiscountClear(cart)) {
        return { cart: cart, cleared: false };
      }
      return postDiscountClear().then(function (updated) {
        document.dispatchEvent(new CustomEvent('lifenuva:cart-discount-cleared', { detail: updated }));
        return { cart: updated, cleared: true };
      });
    }).catch(function () {
      return { cart: null, cleared: false };
    });
  }

  window.LifeNuvaTheme.clearPersistedDiscountCodes = clearPersistedDiscountCodes;

  function updateAllCartBadges(itemCount) {
    var badges = document.querySelectorAll('#cartBadge, .cart-badge, .ln-system-badge');
    badges.forEach(function (badge) {
      badge.textContent = String(itemCount || 0);
      badge.classList.add('is-visible');
    });
  }

  function initResponsiveNavigation() {
    document.querySelectorAll('.nav-wrapper').forEach(function (wrapper, index) {
      var nav = wrapper.querySelector('.nav');
      var links = wrapper.querySelector('.nav-links');
      var icons = wrapper.querySelector('.nav-icons');
      if (!nav || !links || nav.querySelector('.nav-toggle')) return;

      var linksId = links.id || 'LifeNuvaMobileMenu' + index;
      links.id = linksId;

      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'nav-toggle';
      toggle.setAttribute('aria-label', 'Open navigation menu');
      toggle.setAttribute('aria-controls', linksId);
      toggle.setAttribute('aria-expanded', 'false');
      toggle.innerHTML = '<span class="nav-toggle-bars" aria-hidden="true"></span>';
      nav.insertBefore(toggle, icons || links.nextSibling);

      toggle.addEventListener('click', function () {
        var open = !wrapper.classList.contains('is-menu-open');
        wrapper.classList.toggle('is-menu-open', open);
        document.body.classList.toggle('is-nav-menu-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        toggle.setAttribute('aria-label', open ? 'Close navigation menu' : 'Open navigation menu');
      });

      links.addEventListener('click', function (event) {
        if (!event.target.closest('a')) return;
        wrapper.classList.remove('is-menu-open');
        document.body.classList.remove('is-nav-menu-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open navigation menu');
      });
    });

    var systemHeader = document.querySelector('.ln-system-header');
    if (systemHeader && !systemHeader.querySelector('.ln-system-menu-toggle')) {
      var systemNav = systemHeader.querySelector('.ln-system-nav');
      var systemActions = systemHeader.querySelector('.ln-system-actions');
      if (systemNav && systemActions) {
        systemNav.id = systemNav.id || 'LifeNuvaSystemMobileMenu';
        var systemToggle = document.createElement('button');
        systemToggle.type = 'button';
        systemToggle.className = 'ln-system-menu-toggle';
        systemToggle.setAttribute('aria-label', 'Open navigation menu');
        systemToggle.setAttribute('aria-controls', systemNav.id);
        systemToggle.setAttribute('aria-expanded', 'false');
        systemToggle.innerHTML = '<span aria-hidden="true"></span>';
        systemHeader.insertBefore(systemToggle, systemActions);

        systemToggle.addEventListener('click', function () {
          var open = !systemHeader.classList.contains('is-menu-open');
          systemHeader.classList.toggle('is-menu-open', open);
          systemToggle.setAttribute('aria-expanded', String(open));
          systemToggle.setAttribute('aria-label', open ? 'Close navigation menu' : 'Open navigation menu');
        });
      }
    }

    document.addEventListener('click', function (event) {
      document.querySelectorAll('.nav-wrapper.is-menu-open').forEach(function (wrapper) {
        if (wrapper.contains(event.target)) return;
        wrapper.classList.remove('is-menu-open');
        document.body.classList.remove('is-nav-menu-open');
        var toggle = wrapper.querySelector('.nav-toggle');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
      if (systemHeader && systemHeader.classList.contains('is-menu-open') && !systemHeader.contains(event.target)) {
        systemHeader.classList.remove('is-menu-open');
        var toggle = systemHeader.querySelector('.ln-system-menu-toggle');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.nav-wrapper.is-menu-open').forEach(function (wrapper) {
        wrapper.classList.remove('is-menu-open');
        document.body.classList.remove('is-nav-menu-open');
        var toggle = wrapper.querySelector('.nav-toggle');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
          toggle.focus();
        }
      });
      if (systemHeader && systemHeader.classList.contains('is-menu-open')) {
        systemHeader.classList.remove('is-menu-open');
        var systemToggle = systemHeader.querySelector('.ln-system-menu-toggle');
        if (systemToggle) {
          systemToggle.setAttribute('aria-expanded', 'false');
          systemToggle.focus();
        }
      }
    });
  }

  function saveCartBackup(cart) {
    var items = (cart.items || []).map(function (item) {
      return {
        id: item.variant_id,
        quantity: item.quantity,
        properties: item.properties || {}
      };
    });
    sessionStorage.setItem(BACKUP_KEY, JSON.stringify({ items: items }));
    sessionStorage.setItem(RESTORE_KEY, '1');
  }

  function clearCart() {
    return fetch(rootUrl() + 'cart/clear.js', {
      method: 'POST',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to clear cart.');
      return response.json();
    });
  }

  function addItems(items) {
    if (!items || !items.length) {
      return Promise.resolve({ item_count: 0 });
    }
    return fetchJson(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items })
    });
  }

  function restorePreservedCart() {
    if (sessionStorage.getItem(RESTORE_KEY) !== '1') return Promise.resolve(false);

    var raw = sessionStorage.getItem(BACKUP_KEY);
    var backup = null;
    try {
      backup = raw ? JSON.parse(raw) : { items: [] };
    } catch (error) {
      backup = { items: [] };
    }

    return clearCart()
      .then(function () {
        return addItems(backup.items || []);
      })
      .then(function () {
        return fetchJson(rootUrl() + 'cart.js', {
          headers: { Accept: 'application/json' }
        });
      })
      .then(function (cart) {
        updateAllCartBadges(cart.item_count || 0);
        sessionStorage.removeItem(BACKUP_KEY);
        sessionStorage.removeItem(RESTORE_KEY);
        return clearPersistedDiscountCodes().then(function () {
          return true;
        });
      })
      .catch(function () {
        // Keep backup so a later page load can retry.
        return false;
      });
  }

  /**
   * Buy It Now:
   * - checkout only the selected product/qty
   * - go straight to Checkout (same destination as CHECKOUT SELECTED)
   * - keep the shopper's existing cart unchanged by backing it up and restoring on return
   */
  window.LifeNuvaTheme.buyItNow = function (form) {
    return fetchJson(rootUrl() + 'cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (cart) {
        saveCartBackup(cart);
        return clearCart();
      })
      .then(function () {
        var formData = new FormData(form);
        return fetch(rootUrl() + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to start checkout.');
        return response.json();
      })
      .then(function () {
        window.location.href = rootUrl() + 'checkout';
      })
      .catch(function (error) {
        // If checkout handoff fails after mutating the cart, restore the original cart.
        return restorePreservedCart().then(function () {
          throw error;
        });
      });
  };

  function hideDefaultVariantTitles() {
    document.querySelectorAll('.ln-cart-meta').forEach(function (node) {
      var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (text === 'Default Title' || text === '默认规格') node.remove();
    });
  }

  var DISCOUNT_RELOAD_KEY = 'lifenuva_discount_reload';

  function refreshCartAfterDiscountClear(result) {
    sessionStorage.removeItem(DISCOUNT_RELOAD_KEY);
    if (result && result.cleared) {
      document.dispatchEvent(new CustomEvent('lifenuva:cart-discount-cleared', { detail: result.cart }));
    }
  }

  function initDeferredHomeMedia() {
    if (!document.body.classList.contains('template-index')) return;

    var images = document.querySelectorAll('img[data-ln-src]');
    if (!images.length) return;

    function activate(img) {
      if (!img.dataset.lnSrc) return;
      img.src = img.dataset.lnSrc;
      img.removeAttribute('data-ln-src');
      img.loading = 'lazy';
      img.decoding = 'async';
    }

    if (!('IntersectionObserver' in window)) {
      images.forEach(activate);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          activate(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '320px 0px', threshold: 0.01 }
    );

    images.forEach(function (img) {
      observer.observe(img);
    });
  }

  function bootStorefront() {
    initDeferredHomeMedia();
    initResponsiveNavigation();
    hideDefaultVariantTitles();
    restorePreservedCart().then(function (restored) {
      if (restored) return;
      return clearPersistedDiscountCodes().then(refreshCartAfterDiscountClear);
    });
  }

  // When the shopper returns from checkout to the storefront, restore the original cart.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootStorefront);
  } else {
    bootStorefront();
  }

  window.addEventListener('pageshow', function () {
    restorePreservedCart().then(function (restored) {
      if (restored) return;
      return clearPersistedDiscountCodes().then(refreshCartAfterDiscountClear);
    });
  });
})();
